import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { TILE_SIZE_PX } from 'LayoutBuilderUI/components/tiles/tileUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingTile = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    inlineSize: TILE_SIZE_PX.medium,
    blockSize: TILE_SIZE_PX.medium,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "fill-tertiary-hover",
    borderColor: "border-tertiary-default",
    borderRadius: "200",
    borderWidth: "100",
    borderStyle: "solid",
    padding: "100",
    boxShadow: "300",
    position: "relative",
    children: [/*#__PURE__*/_jsx(View, {
      alignSelf: "center",
      marginBlock: "auto",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    }), /*#__PURE__*/_jsx(Text, {
      as: "small",
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "layoutBuilder.addPanel.loadingTile.title"
      })
    })]
  });
};
export default LoadingTile;